import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import MediaLibrary from '@/pages/dashboard/apps/content-studio/components/MediaLibrary';

export default function ContentStudioMediaPage() {
  const { user } = useAuth();

  if (!user?.id) {
    return (
      <div className="flex items-center justify-center py-24">
        <i className="ri-loader-4-line animate-spin text-2xl text-accent-500"></i>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 max-w-6xl mx-auto">
      <Link
        to="/dashboard/content-studio"
        className="inline-flex items-center gap-1.5 text-sm text-foreground-500 hover:text-foreground-800 transition-colors mb-4 cursor-pointer"
      >
        <i className="ri-arrow-left-line"></i>
        Content Studio
      </Link>

      <div className="mb-6">
        <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 flex items-center gap-2">
          <i className="ri-gallery-line text-accent-500"></i>
          Bibliothèque média du studio
        </h2>
        <p className="text-sm text-foreground-500 mt-1">
          Tous vos médias au même endroit : importez, recherchez, filtrez et rattachez à vos scènes.
        </p>
      </div>

      <MediaLibrary ownerId={user.id} />
    </div>
  );
}